export default __webpack_public_path__ + "static/media/vr_dark.a1dda6a8.png";